<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-xmla-subscription-price-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        name="data.subscriptionTypeId"
        [(ngModel)]="data.subscriptionTypeId"
        (selectionChange)="selectedSubTypeChanged()"
      >
        <mat-option
          *ngFor="let subTypes of data.xmlaSubscriptionTypes"
          value="{{ subTypes.xmlaSubscriptionTypeId }}"
          >{{ subTypes.xmlaSubscriptionName }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let subTypes of data.xmlaSubscriptionTypes">
          <ng-container
            *ngIf="subTypes.xmlaSubscriptionTypeId == data.subscriptionTypeId"
          >
            {{ subTypes.xmlaSubscriptionName }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Level</mat-label>
      <mat-select
        name="data.subscriptionLevelId"
        [(ngModel)]="data.subscriptionLevelId"
      >
        <mat-option
          *ngFor="let subLevel of filteredSubLevels"
          value="{{ subLevel.xmlaSubscriptionLevelId }}"
          >{{ subLevel.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Level</mat-label>
      <div>
        <ng-container *ngFor="let subLevel of data.xmlaSubscriptionLevels">
          <ng-container
            *ngIf="
              subLevel.xmlaSubscriptionLevelId == data.subscriptionLevelId &&
              subLevel.xmlaSubscriptionTypeId == data.subscriptionTypeId
            "
          >
            {{ subLevel.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Period Type</mat-label>
      <mat-select name="data.periodTypeId" [(ngModel)]="data.periodTypeId">
        <mat-option
          *ngFor="let subPeriod of data.subPeriodTypes"
          value="{{ subPeriod.periodTypeId }}"
          >{{ subPeriod.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Period Type</mat-label>
      <div>
        <ng-container *ngFor="let subPeriod of data.subPeriodTypes">
          <ng-container *ngIf="subPeriod.periodTypeId == data.periodTypeId">
            {{ subPeriod.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Price</mat-label>
      <input
        matInput
        name="data.price"
        [(ngModel)]="data.price"
      /> </mat-form-field
    ><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Price
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
